import React from 'react'
import PropTypes from 'prop-types'
import { cn } from '../modules'
import Skeleton from './Skeleton'

function NewsListItemSocialSkeleton({ className }) {
  return (
    <Skeleton className={cn('block h-full w-full aspect-square rounded-lg', className)} />
  )
}

NewsListItemSocialSkeleton.propTypes = {
  className: PropTypes.string,
}

NewsListItemSocialSkeleton.defaultProps = {
  className: null,
}

export default NewsListItemSocialSkeleton
